module.exports = __webpack_public_path__ + "img/ex (1).85f20ba5.jpeg";